import type { Ref } from 'vue';
import type { Emits as MetaTagAddEmits } from '@/components/meta/MetaTagAdd.vue';
import type { Emits as MetaTagEmits, Props as MetaTagProps } from '@/components/meta/MetaTags.vue';
import type { Emits as MetaRatingEmits, Props as MetaRatingProps } from '@/components/meta/MetaRating.vue';
import type { Metadata } from '@/stores/ImageMetadata';
import type { Image } from '@/stores/api';

export type MediaSlideProps = {
  source: Image;
  media?: Metadata;
  isMobile: boolean;
  isVisible?: boolean;
  isCurrent?: boolean;
  canRevealResolvedMedia?: boolean;
  showBlockingLoader?: boolean;
  canSkipLoader?: boolean;
};

export const MEDIA_SLIDE_PROPS_DEFAULTS = {
  media: undefined,
  isVisible: true,
  isCurrent: false,
  canRevealResolvedMedia: true,
  showBlockingLoader: false,
  canSkipLoader: false,
};

export type ClickedElementType = 'img' | 'video';

export type MediaSlideEmits = {
  (e: 'mediaClicked', element: ClickedElementType, event: MouseEvent): void;
  (e: 'presentationReadyChange', ready: boolean): void;
  (e: 'skipLoader'): void;
};

export type MetaSlideProps = {
  isMobile: boolean;
  source: Image;
} & MetaTagProps & MetaRatingProps;

export type MetaSlideEmits = MetaTagEmits & MetaTagAddEmits & MetaRatingEmits;

export type MediaMetaSlideGroupProps = MediaSlideProps & MetaSlideProps;
export type MediaMetaSlideGroupEmits = MediaSlideEmits & MetaSlideEmits;

export type MediaMetaSlideGroupExposed = {
  liMediaRef: Ref<HTMLLIElement | undefined>;
  liMetaRef: Ref<HTMLLIElement | undefined>;
};
